/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  CreateInvoiceMutationRequest,
  CreateInvoiceMutationResponse,
} from "../types/CreateInvoice.ts"
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { mutationOptions, useMutation } from "@tanstack/react-query"

export const createInvoiceMutationKey = () =>
  [{ url: "/v1/invoice/create-invoice" }] as const

export type CreateInvoiceMutationKey = ReturnType<
  typeof createInvoiceMutationKey
>

/**
 * @summary Create an invoice
 * {@link /v1/invoice/create-invoice}
 */
export async function createInvoice(
  data: CreateInvoiceMutationRequest,
  config: Partial<RequestConfig<CreateInvoiceMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    CreateInvoiceMutationResponse,
    ResponseErrorConfig<Error>,
    CreateInvoiceMutationRequest
  >({
    method: "POST",
    url: `/v1/invoice/create-invoice`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function createInvoiceMutationOptions<TContext = unknown>(
  config: Partial<RequestConfig<CreateInvoiceMutationRequest>> & {
    client?: Client
  } = {}
) {
  const mutationKey = createInvoiceMutationKey()
  return mutationOptions<
    ResponseConfig<CreateInvoiceMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateInvoiceMutationRequest },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return createInvoice(data, config)
    },
  })
}

/**
 * @summary Create an invoice
 * {@link /v1/invoice/create-invoice}
 */
export function useCreateInvoice<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<CreateInvoiceMutationResponse>,
      ResponseErrorConfig<Error>,
      { data: CreateInvoiceMutationRequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<CreateInvoiceMutationRequest>> & {
      client?: Client
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? createInvoiceMutationKey()

  const baseOptions = createInvoiceMutationOptions(
    config
  ) as UseMutationOptions<
    ResponseConfig<CreateInvoiceMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateInvoiceMutationRequest },
    TContext
  >

  return useMutation<
    ResponseConfig<CreateInvoiceMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateInvoiceMutationRequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<CreateInvoiceMutationResponse>,
    ResponseErrorConfig<Error>,
    { data: CreateInvoiceMutationRequest },
    TContext
  >
}
